/**
 * Conteúdo dos módulos do exame CFA (Chartered Financial Analyst)
 * Extraído para facilitar manutenção e permitir atualizações sem modificar código React
 */

export const CFA_MODULES_CONTENT = [
  {
    id: 1,
    title: 'Módulo 1 - Quantitative Methods',
    description: 'É um módulo com dificuldade moderada, em que há a abordagem de questões envolvendo uma parte mais puramente matemática, como o cálculo de taxas, probabilidade e estatística. Acreditamos que caia cerca de 14 questões na sua prova.',
    recommendedPerformance: '65%'
  },
  {
    id: 2,
    title: 'Módulo 2 - Economics',
    description: 'Neste módulo vemos principalmente questões sobre macroeconomia, microeconomia, ciclos econômicos e a dinâmica econômica internacional. Aqui consideramos que seja um módulo com grau de dificuldade médio, e que deva conter cerca de 14 questões na sua prova.',
    recommendedPerformance: '75%'
  },
  {
    id: 3,
    title: 'Módulo 3 - Corporate Issuers',
    description: 'Aqui é cobrado que o candidato entenda a dinâmica de uma empresa, e domine conceitos como estrutura de capital, custo de capital, WACC (CMPC), governança, e outros. Este é um módulo de dificuldade média. Acreditamos que seja cobrado cerca de 13 questões na sua prova sobre esses assuntos.',
    recommendedPerformance: '70%'
  },
  {
    id: 4,
    title: 'Módulo 4 - Financial Statement Analysis',
    description: 'Aqui no módulo 4 é cobrado que o candidato entenda sobre a contabilidade de empresas em padrões internacionais estabelecidos, com foco em análise de balanços e demonstrativos financeiros. É considerado um módulo difícil, ao mesmo tempo que é bastante relevante para a sua aprovação. Acreditamos que caia cerca de 22 questões na sua prova.',
    recommendedPerformance: '60%'
  },
  {
    id: 5,
    title: 'Módulo 5 - Equity Investments',
    description: 'É considerado um módulo com grau de dificuldade média, e que possuímos a expectativa de que caia cerca de 20 questões na sua prova. Neste módulo o CFA cobra principalmente conceitos relacionados ao mercado de renda variável, como índices de mercado, análises setoriais e empresariais, dentre outros.',
    recommendedPerformance: '75%'
  },
  {
    id: 6,
    title: 'Módulo 6 - Fixed Income',
    description: 'Neste módulo é cobrado que o candidato domine conceitos relacionados ao mercado de renda fixa, como avaliação de riscos, cálculos de duration, cálculos de medidas de retorno como YtM, CY, e mais. Este é um módulo de dificuldade média, e que temos a expectativa que sejam cobrados cerca de 22 questões.',
    recommendedPerformance: '80%'
  },
  {
    id: 7,
    title: 'Módulo 7 - Derivatives',
    description: 'Este é um módulo de dificuldade consideravelmente superior aos outros, em que é cobrado sobre contratos futuros, swap, opções, e outros. Acreditamos que caia cerca de 14 questões.',
    recommendedPerformance: '50%'
  },
  {
    id: 8,
    title: 'Módulo 8 - Alternative Investments',
    description: 'Neste módulo é cobrado que o candidato compreenda conceitos relacionados ao mercado de investimentos alternativos, bem como entenda como os produtos (Private Equity, Venture Capital, Real Estate, e outros) são estruturados e avaliados. Este é um módulo de dificuldade fácil, e que acreditamos que seja cobrado cerca de 13 questões.',
    recommendedPerformance: '90%'
  },
  {
    id: 9,
    title: 'Módulo 9 - Portfolio Management',
    description: 'Nesta parte da prova vemos questões a respeito da teoria e prática da gestão de carteiras de investimentos, em que aparecem conceitos como política de investimentos, métricas de risco como Índice de Sharpe, e finanças comportamentais. Este é um módulo de dificuldade moderada, e que acreditamos que caia cerca de 21 questões.',
    recommendedPerformance: '70%'
  },
  {
    id: 10,
    title: 'Módulo 10 - Ethical and Professional Standards',
    description: 'Este é o módulo mais cobrado no exame, em que acreditamos que terá cerca de 27 questões na sua prova. Aqui temos a cobrança dos princípios e processos éticos do CFA Institute, que enquadramos como um conteúdo de dificuldade fácil.',
    recommendedPerformance: '90%'
  }
];

/**
 * Retorna o conteúdo dos módulos com quebras de página inseridas nos índices especificados
 * @param {number[]} breakPageIndices - Índices onde inserir quebras de página (ex: [2, 5, 7])
 * @returns {Array} Array de módulos com objetos de quebra de página inseridos
 */
export const getModulesWithPageBreaks = (breakPageIndices = [2, 5, 7]) => {
  const modulesWithBreaks = [];
  
  CFA_MODULES_CONTENT.forEach((module, index) => {
    modulesWithBreaks.push(module);
    
    // Adiciona quebra de página após os índices especificados
    if (breakPageIndices.includes(index)) {
      modulesWithBreaks.push({ type: 'pageBreak' });
    }
  });
  
  return modulesWithBreaks;
};
